export const TABLET_BREAKPOINT = 976;
